const TitleObj = {
  1: 'Add New Record',
  2: 'Edit/Update Record Details',
  3: 'Upload Files',
  4: 'Approve Record',
  5: 'Edit/Update Record Details',
};

export default TitleObj;
